import { Component, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { DeviceEssService } from '../../../Model/DeviceEss/device-ess.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SessionService } from '../../../Util/Session/session.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';

@Component({
  selector: 'app-device-attendance',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule, NgSelectModule, NgbDatepickerModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './device-attendance.component.html',
  styleUrl: './device-attendance.component.scss'
})
export class DeviceAttendanceComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  FilterIndex = 0;
  AllData: any[] = [];
  Data: any[] = [];
  filter = {
    FromDate: null as any,
    ToDate: null as any,
    Today: null as any,
    DateType: 2,
    startOfMonth: null as any,
    endOfMonth: null as any,
  }

  Devicefilter = {
    endPoint: "DeviceESS/deviceattendance",
    requestBody: {
      DeviceSerialNo: null,
      FromDate: null as any,
      ToDate: null as any,
      Type: 1,
      CompanyCode: null,
      IsExcel: false,
    },
    httpMethod: "Post"
  }

  Card = {
    TotalPunch: 0,
    InPunch: 0,
    InPunchPer: 0 as any,
    OutPunch: 0,
    OutPunchper: 0 as any,
    UniqPunch: 0,
    SyncCount: 0,
    SyncRate: 0 as any,
    UnSyncCount: 0,
    UnSyncRate: 0 as any,
  }
  dtoptions: DataTables.Settings = {};
  DeviceData: any[] = [];
  DeviceInfoCard = {
    status: 0,
    DeviceSerialNo: null,
  }
  Sites = [] as any;

  constructor(
    protected common: CommonService,
    private modalService: NgbModal,
    private deviceess: DeviceEssService,
    private route: ActivatedRoute,
    private session: SessionService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    private employeeRegistration: EmployeeRegistrationService,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.Devicefilter.requestBody.DeviceSerialNo = params['sn']);
    this.Devicefilter.requestBody.CompanyCode = this.session.GetUserDetails().CompanyCode;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
    this.ESS_AdditionalFillCombo();
    this.GetDeviceDetail();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.Datesetfilter();
    }
    else {
      form.submitted = true;
    }
  }

  ESS_SiteWiseDeviceDetailsSelect(IsExcel = false) {
    this.isDisabled = true;
    this.Devicefilter.requestBody.FromDate = this.dateFormat.format(this.filter.FromDate);
    this.Devicefilter.requestBody.ToDate = this.dateFormat.format(this.filter.ToDate);
    this.Devicefilter.requestBody.IsExcel = IsExcel;

    this.deviceess.commonDeviceApi(this.Devicefilter).subscribe({
      next: (response) => {
        try {
          if ((!IsExcel && response && response.length > 0) || (IsExcel && response)) {
            if (IsExcel && response.success) {
              window.open(response.path, '_blank', 'noopener noreferrer');
            } else if (!IsExcel) {
              this.Card.TotalPunch = response.length;
              this.Card.InPunch = response.filter((e: any) => this.common.ToLowerCase(e.PunchType) == 'in').length;
              this.Card.InPunchPer = ((this.Card.InPunch * 100) / this.Card.TotalPunch).toFixed(2);
              this.Card.OutPunch = response.filter((e: any) => this.common.ToLowerCase(e.PunchType) == 'out').length;
              this.Card.OutPunchper = ((this.Card.OutPunch * 100) / this.Card.TotalPunch).toFixed(2);
              this.Card.UniqPunch = [...new Set(response.map((e: any) => e.EmployeeDetailsId))].length;
              this.Card.SyncCount = response.filter((e: any) => e.IsSync).length;
              this.Card.SyncRate = ((this.Card.SyncCount * 100) / this.Card.TotalPunch).toFixed(2);
              this.Card.UnSyncCount = response.filter((e: any) => !e.IsSync).length;
              this.Card.UnSyncRate = ((this.Card.UnSyncCount * 100) / this.Card.TotalPunch).toFixed(2);

              this.AllData = response;
              this.Data = Object.values(response);

              [...new Set(this.AllData.filter(e => e.ImagePath == null || e.ImagePath == '').map(e => e.EmployeeDetailsID))].forEach(element => {
                this.GetProfileImage(element);
              });

              try {
                this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                  dtInstance.destroy();
                  this.dtTrigger.next(null);
                });
              } catch (e) { }
            }
          } else {
            if (!IsExcel && response.length == 0) {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = "Not Data available";
              modalRef.result.then((result: any) => { });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.ClearData();
          }

        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetAttendanceDataExcel(IsExcel = false) {
    this.isDisabled = true;
    this.deviceess.commonDeviceApi({
      endPoint: "DeviceESS/AttendanceDataExcel",
      requestBody: {
        DeviceSerialNo: this.Devicefilter.requestBody.DeviceSerialNo,
        FromDate: this.dateFormat.format(this.filter.FromDate),
        ToDate: this.dateFormat.format(this.filter.ToDate),
        Type: 1,
        CompanyCode: this.Devicefilter.requestBody.CompanyCode,
      },
      httpMethod: "Post"
    }).subscribe({
      next: (response) => {
        try {
          if (response) {
            if (response.success) {
              window.open(response.path, '_blank', 'noopener noreferrer');
            }
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.filter.Today = response.Table[0].RegistrationDate;
          this.Datesetfilter();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Datesetfilter() {
    const date = new Date(this.filter.Today);

    if (this.filter.DateType == 1) {
      this.filter.startOfMonth = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
      this.filter.endOfMonth = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
    } else if (this.filter.DateType == 2) {
      this.filter.startOfMonth = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      this.filter.endOfMonth = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    } else if (this.filter.DateType == 3) {
      this.filter.ToDate = this.filter.FromDate;
    } else if (this.filter.DateType == 5) {
      this.filter.startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      this.filter.endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    if (this.filter.DateType == 1 || this.filter.DateType == 2 || this.filter.DateType == 5) {
      this.filter.FromDate = this.dateFormat.parse(this.filter.startOfMonth.getDate() + " " + this.dateFormat.month[this.filter.startOfMonth.getMonth()] + " " + this.filter.startOfMonth.getFullYear());
      this.filter.ToDate = this.dateFormat.parse(this.filter.endOfMonth.getDate() + " " + this.dateFormat.month[this.filter.endOfMonth.getMonth()] + " " + this.filter.endOfMonth.getFullYear());
    }

    this.ESS_SiteWiseDeviceDetailsSelect();
  }

  ClearData() {
    this.AllData = [];
    this.Data = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.Card = {
      TotalPunch: 0,
      InPunch: 0,
      InPunchPer: 0,
      OutPunch: 0,
      OutPunchper: 0,
      UniqPunch: 0,
      SyncCount: 0,
      SyncRate: 0,
      UnSyncCount: 0,
      UnSyncRate: 0,
    }
  }

  FilterData(index: number) {
    if (this.FilterIndex == index) {
      this.Data = Object.values(this.AllData);
      this.FilterIndex = 0;
    } else {
      this.FilterIndex = index;
      if (index == 1) {
        this.Data = Object.values(this.AllData);
      } else if (index == 1.1) {
        this.Data = Object.values(this.AllData.filter((e: any) => this.common.ToLowerCase(e.PunchType) == 'in'));
      } else if (index == 1.2) {
        this.Data = Object.values(this.AllData.filter((e: any) => this.common.ToLowerCase(e.PunchType) == 'out'));
      } else if (index == 2) {
        this.Data = Object.values(this.AllData.filter((e: any) => this.common.ToLowerCase(e.PunchType) == 'in'));
      } else if (index == 3) {
        this.Data = Object.values(this.AllData);
      } else if (index == 3.1) {
        this.Data = Object.values(this.AllData.filter((e: any) => e.IsSync).length);
      } else if (index == 3.2) {
        this.Data = Object.values(this.AllData.filter((e: any) => !e.IsSync).length);
      }
    }
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }

  GetDevices() {
    this.isDisabled = true;
    this.DeviceData = [];
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/devicestatus", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, BSCode: this.Sites.map((e: any) => e.SiteMasterID).toString() }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response && response.length > 0) {
            this.DeviceData = response;
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDeviceDetail() {
    this.isDisabled = true;
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/devicestatus", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, DeviceSerialNo: this.Devicefilter.requestBody.DeviceSerialNo }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response && response.length > 0) {
            this.DeviceInfoCard.status = response[0].status;
            this.DeviceInfoCard.DeviceSerialNo = response[0].serial_num;
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetProfileImage(EmployeeDetailsID: number) {
    this.isDisabled = true;
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/profileimage", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, DeviceSerialNo: this.Devicefilter.requestBody.DeviceSerialNo, EmployeeDetailsID: EmployeeDetailsID }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response.success && response.image != null && response.image != "") {
            this.AllData.filter(e => e.EmployeeDetailsID == EmployeeDetailsID).forEach(element => {
              element.Base64 = response.image;
            });

            if (this.Data.filter(e => e.EmployeeDetailsID == EmployeeDetailsID).length > 0) {
              this.Data.filter(e => e.EmployeeDetailsID == EmployeeDetailsID).forEach(element => {
                element.Base64 = response.image;
              });
            }
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onNavigate(event: any) {
    this.filter.FromDate = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.Sites = [];

    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'SW', UserId: this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.Sites = [...new Map(response.Table1.map((e: any) => ({ SiteMasterID: e.SiteCode, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];

          this.GetDevices()
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
